// ante-react-kit/src/components/AntQuickPopup/helpers/QPSection.js
import React, { useState, useMemo } from 'react';
import { useQuickPopupContext } from '../QuickPopupContext';
import AntLocalization from '../../../utils/AntLocalization';
import AntCondition from '../../../utils/AntCondition';

export default function QPSection(props) {
    const { title, collapsible = false, defaultOpen = true, visible, visibleSelf, colCount = 2, children } = props;
    const ctx = useQuickPopupContext();
    const [open, setOpen] = useState(defaultOpen);

    const isVisible = useMemo(() => {
        if (visible && ctx && !ctx.checkVisible(visible)) return false;
        if (visibleSelf && ctx && !AntCondition.isValid(ctx.data || {}, visibleSelf)) return false;
        return true;
    }, [visible, visibleSelf, ctx]);

    if (!isVisible) return null;

    const resolvedTitle = title ? AntLocalization.translateText(title) || title : null;

    return (
        <section className="qp-section" style={{ marginBottom: 16 }}>
            {resolvedTitle && (
                <header
                    onClick={() => collapsible && setOpen(!open)}
                    style={{
                        display: 'flex', alignItems: 'center', gap: 6,
                        fontSize: 12, fontWeight: 600, color: '#1a3561',
                        textTransform: 'uppercase', letterSpacing: 0.5,
                        cursor: collapsible ? 'pointer' : 'default',
                        userSelect: 'none',
                        marginBottom: 10, paddingBottom: 6,
                        borderBottom: '1px solid #e2e8f0'
                    }}
                >
                    {collapsible && <span style={{ display: 'inline-block', width: 10, transform: open ? 'rotate(90deg)' : 'rotate(0)', transition: 'transform 0.15s' }}>&#9658;</span>}
                    {resolvedTitle}
                </header>
            )}
            {open && (
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))`,
                    columnGap: 16
                }}>
                    {children}
                </div>
            )}
        </section>
    );
}
